import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from './theme';

const theme = createAppTheme();

/**
 * App theme provider with light + dark color schemes.
 * Mode defaults to the OS preference and is persisted to localStorage
 * (MUI `useColorScheme` handles storage under the "mui-mode" key).
 */
export const ThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme} defaultMode="system" disableTransitionOnChange>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
